import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { NativeLoadingTemplate } from "~/features/native-auth/NativeLoadingTemplate";

const nativeLoadingSearchSchema = z.object({
  idfv: z.string().optional(),
  appId: z.coerce.string().optional(),
  app: z.string().optional(),
  lang: z.string().optional(),
});

export const Route = createFileRoute("/native/loading")({
  validateSearch: nativeLoadingSearchSchema,
  component: NativeLoadingTemplate,
});
